interface ResponsiveLayoutSizesProps {
  columnCount?: number;
  viewportSizes?: string;
}

export const getResponsiveImageSizes = ({
  columnCount,
  viewportSizes,
}: ResponsiveLayoutSizesProps) => {
  if (!viewportSizes) {
    return {
      imageSizes: `(width <= 768px) 100vw, ${Math.floor(100 / (columnCount || 1))}vw`,
    };
  }

  const [mobile, tablet, desktop] = viewportSizes.split(',');

  return {
    imageSizes: `(width <= 768px) ${mobile}, (width <= 1024px) ${tablet}, ${desktop}`,
  };
};
